import styled from 'styled-components';

export const InputRadioGroup = styled.div`
  width: 90%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 1.8rem;
  margin-bottom: 6rem;
`;
